import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Founder.css';

const Founder = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <div className='app__founder-image'>
        <img src={images.founder} alt="founder" />
      </div>
    </div>

    <div className="app__wrapper_info">
      <SubHeading title="CEO's Word" />
      <h1 className="headtext__italiana">What We Believe In</h1>

      <div className="app__founder-content">
        <div className="app__founder-content_quote">
          <img src={images.quote} alt="quote" />
          <p className="p__opensans">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
        </div>
        <p className="p__opensans">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
      </div>

      <div className="app__founder-sign">
        <p>Laura Gold</p>
        <p className='p__opensans'>Designer & Founder</p>
        <img src={images.sign} alt="sign" />
      </div>
    </div>
  </div>
);

export default Founder;
